import { useEffect } from "react";
import { getExternalImportFiles } from "./product/import/ProductImportRepository";
import { angularEvents } from "../bridge/angularEvents";
import { reactEvents } from "../bridge/reactEvents";

interface AngularEventListenerProps {
    children: React.ReactNode
}
export function GlobalAngularEventListener({ children }: AngularEventListenerProps) {

    useEffect(() => {
        const unsubProductImportViewLoaded = angularEvents.productImportViewLoaded.subscribe(() => {
            checkExistsExternalImports()
        });

        return () => {
            unsubProductImportViewLoaded();
        }
    }, [])


    function checkExistsExternalImports() {
        getExternalImportFiles().then((data) => {
            if (data.length > 0) {
                reactEvents.externalImportsExist.dispatch();
            }
        })
    }

    return <div>{children}</div>
}